const o = {
  "control-group": "control-group",
  "control-group__item": "control-group__item",
  "control-group__item--growing": "control-group__item--growing"
};
export {
  o as default
};
